import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
const SEGUNDOS_OFERTA = 13 * 3600 + 26 * 60 + 42;
export function CountdownInline() {
  const {
    horas,
    minutos,
    segundos
  } = useCountdown(SEGUNDOS_OFERTA);
  return <span className="inline-flex items-center gap-1.5 font-semibold tabular-nums text-naranja" role="timer" aria-live="off" aria-label={`Quedan ${horas} horas, ${minutos} minutos y ${segundos} segundos`} style={{
    color: "#823400"
  }} data-id="element-101" data-mp="2nmi51vww8fzj">
      <span aria-hidden="true" data-id="element-102" data-mp="2xhtjse8axn7a">⏳</span>
      {horas}h : {minutos}m : {segundos}s
    </span>;
}